// extracted by mini-css-extract-plugin
export default {"sbContainer":"styles_sbContainer__YoLkU"};